import {DetailsPageAppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/context'
import {OrderFailedOwnProps, OrderFailedProps, OrderFailedRuntimeProps} from './interfaces'
import {OrderFailed as Presentation} from './order-failed'

const mapRuntimeToProps = ({
  actions: {navigateToDetailsOld, navigateToDetails},
}: DetailsPageAppProps): OrderFailedProps => ({
  navigateToDetailsOld,
  navigateToDetails,
})

export const OrderFailed = connect<OrderFailedOwnProps, OrderFailedRuntimeProps>(mapRuntimeToProps)(Presentation)
